import React from 'react';

// Format duration display helper
const formatDuration = (duration) => {
  if (duration < 1) {
    return `${(duration * 60).toFixed(0)} min`;
  }
  return `${duration.toFixed(1)} hours`;
};

const SegmentTable = React.memo(function SegmentTable({ segments, totalDuration, title, className, locations, connections }) {
  const segmentRows = React.useMemo(() => {
    if (!segments || segments.length === 0 || !connections) return [];
    
    return segments.map((segment, index) => {
      // Find connection between the two points
      const connection = connections.find(conn => {
        if (!conn.points || conn.points.length !== 2) return false;
        const [point1, point2] = conn.points;
        return (
          (point1.id === segment.from.id && point2.id === segment.to.id) ||
          (point2.id === segment.from.id && point1.id === segment.to.id)
        );
      });
      
      const duration = connection && connection.duration ? parseFloat(connection.duration) : 0;
      
      return (
        <tr key={index}>
          <td>{segment.from.name} → {segment.to.name}</td>
          <td>{duration > 0 ? `${duration.toFixed(1)} hours` : 'No data'}</td>
        </tr>
      );
    });
  }, [segments, totalDuration, connections]);
  
  const formattedDuration = React.useMemo(() => {
    return totalDuration ? `${totalDuration.toFixed(1)} hours` : "0.0 hours";
  }, [totalDuration]);
  
  if (!segments || segments.length === 0) {
    return (
      <div className={`segment-table ${className}`}>
        <h6>{title}</h6>
        <p>No segment data available</p>
      </div>
    );
  }
  
  return (
    <div className={`segment-table ${className}`}>
      <h6>{title}</h6>
      <table>
        <thead>
          <tr>
            <th>Segment</th>
            <th>Duration</th>
          </tr>
        </thead>
        <tbody>
          {segmentRows}
        </tbody>
        <tfoot>
          <tr>
            <td><strong>Total</strong></td>
            <td><strong>{formattedDuration}</strong></td>
          </tr>
        </tfoot>
      </table>
    </div>
  );
});

export default SegmentTable; 